export const getTerritoryCommunityPageUrl = (territorySlug: string): string => `/t/${territorySlug}/community`;
